<template web>
  <v-app id="inspire" class="myFont">
    <!-- header  -->
    <v-app-bar
      :height=" isMobile ? 56 : 78"
      v-if="mostrarMenu()"
      class="white px-0 px-sm-4 index-20"
      app
      clipped-right
      elevate-on-scroll
    >
      <v-app-bar-nav-icon class="d-flex d-md-none" @click.stop="left = !left"></v-app-bar-nav-icon>
      <!-- logo  -->
      <v-toolbar-title class="pa-0 ma-0 d-inline-flex" @click="$router.push('/')">
        <v-img
          class="pa-0"
          src="/img/logoFunEats.svg"
          lazy-src="/img/logoFunEats.svg"
          contain
          :height=" isMobile ? 24 : 38"
          width="150"
        ></v-img>
      </v-toolbar-title>

      <headerToolbarRestaurante v-if="esDomicilio && activeRestObj" />
      <v-spacer></v-spacer>
      <!-- <v-btn @click="comprobarPedido">COMPROBAR</v-btn> -->
      <!-- Menu Usuario  -->
      <cuentaMenuUser />

      <v-app-bar-nav-icon class @click.stop="cartDrawer = !cartDrawer">
        <v-badge color="light-blue darken-2" overlap bottom left>
          <template v-slot:badge>{{cantidad}}</template>
          <v-icon size="28">mdi-cart-outline</v-icon>
        </v-badge>
      </v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Menú movil -->
    <v-navigation-drawer v-if="mostrarMenu" v-model="left" fixed temporary touchless>
      <v-list class="border">
        <router-link
          v-for="route in items"
          :key="route.path"
          :to="route.path"
          v-slot="{ href, route, navigate, isActive }"
        >
          <v-list-item :active="isActive" :href="href" @click="navigate">
            <v-list-item-action class="mr-3">
              <v-icon>{{route.meta.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ route.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
    </v-navigation-drawer>

    <!-- Carritos productos-->
    <finalizarCarrito />

    <!-- Contenido de la web -->

    <v-content class>
      <router-view />
      <v-snackbar v-model="snackbar" :color="snackbar_color">
        {{ snackbar_text }}
        <v-btn text @click.stop="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
      <v-snackbar v-model="snackbarEmail" color="success" :timeout="0" vertical right persistent>
        <v-btn absolute right class="mt-0" text icon @click="snackbarEmail = false">
          <v-icon class="black--text">mdi-close</v-icon>
        </v-btn>
        <h3>Introduce tu email</h3>
        <v-text-field
          v-model="email"
          color="black"
          background-color="white"
          rounded
          placeholder="Email"
        />
        <v-btn text @click="saveEmail" :loading="loadingEmail">Guardar</v-btn>
      </v-snackbar>
      <v-snackbar v-model="snackbarEmail2" color="white" :timeout="0" vertical right persistent>
        <v-btn
          tile
          small
          class="my-auto mr-auto ml-0"
          color="grey darken-4"
          @click="enviarEmail"
          text
        >Reenviar Email para confirmar</v-btn>
        <v-spacer></v-spacer>
        <v-btn absolute right class="ma-0 pa-0" text icon @click="snackbarEmail2 = false">
          <v-icon class>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>


<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import headerToolbarRestaurante from "@/components/Pedidos/pedir_toolbarRestaurante.vue";
import finalizarCarrito from "@/components/Pedidos/pedir_carritoLateral.vue";
import cuentaMenuUser from "@/components/TuCuenta/tuCuenta_menuUser.vue";

import firebase from "firebase";

export default {
  name: "App",
  components: {
    finalizarCarrito,
    headerToolbarRestaurante,
    cuentaMenuUser
  },
  data() {
    return {
      loadingEmail: false,
      email: "",
      items: [],
      itemsLogueado: [],
      tuCuenta: [],
      drawer: false,
      left: false
    };
  },
  computed: {
    confirmarEmail() {
      return this.user.email;
    },

    snackbarEmail: {
      get() {
        return (
          this.$store.state.auth.snackbarEmail &&
          this.logged &&
          !this.user.email
        );
      },
      set(value) {
        this.$store.commit("auth/setSnackbarEmail", value);
      }
    },
    snackbarEmail2: {
      get() {
        return (
          this.$store.state.auth.snackbarEmail2 &&
          this.logged &&
          this.user.email &&
          !this.user.emailVerified
        );
      },
      set(value) {
        this.$store.commit("auth/setSnackbarEmail2", value);
      }
    },
    snackbar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit("snackbar/reset");
      }
    },
    ...mapState({
      // arrow functions can make the code very succinct!
      dialog: state => state.pedido.continuePedido,
      snackbar_text: state => state.snackbar.text,
      snackbar_color: state => state.snackbar.color,
      logged: state => state.auth.isLogged,
      user: state => state.auth.user,
      activeRestObj: state => state.pedido.restauranteObjPedido,
      title: state => state.app.titlePage,
      productos: state => state.restaurante.prodActiveCat.productos,
      carrito: state => state.pedido.carrito.productos,
      loadingCarrito: state => state.pedido.loadingCarrito,
      cantidad: state => state.pedido.carrito.numero_producto,
      precio: state => state.pedido.carrito.precio_total,
      loadingQuantity: state => state.pedido.loadingQuantity,
      isLogged: state => state.auth.isLogged
    }),
    ...mapGetters({
      //cantidad: 'pedido/precioPedido'
      esDomicilio: "pedido/esDomicilio"
    }),

    isMobile: {
      get() {
        return this.$store.state.app.isMobile;
      },
      set(v) {
        this.$store.commit("app/setIsMobile", v);
      }
    },
    isSafari: {
      get() {
        return this.$store.state.app.isSafari;
      },
      set(v) {
        this.$store.commit("app/setIsSafari", v);
      }
    },
    cartDrawer: {
      get() {
        return this.$store.state.app.cartDrawer;
      },
      set(value) {
        this.$store.commit("app/setCartDrawer", value);
      }
    },
    cantidadConX: function(data) {
      return data + "x";
    },
    primerProducto() {
      if (this.carrito && this.carrito[0] != undefined) {
        return this.carrito[0].nombre;
      }
      return "producto";
    },
    dialogIdiomas: {
      get() {
        return this.$store.state.app.dialogIdiomas;
      },
      set(value) {
        this.$store.commit("app/setDialogIdiomas", value);
      }
    },
    dialogLogin: {
      get() {
        return this.$store.state.app.dialogLogin;
      },
      set(value) {
        this.$store.commit("app/setDialogLogin", value);
      }
    }
  },

  methods: {
    saveEmail() {
      let _vm = this;
      this.loadingEmail = true;
      this.$store
        .dispatch("auth/savePerfil", {
          email: this.email
        })
        .then(function(r) {
          _vm.$store.commit("snackbar/setMensajeInfo", {
            msj: "Revisa tu correo y confirma tu email. Gracias!"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el email: " + e
          });
        })
        .finally(function() {
          _vm.loadingEmail = false;
        });
    },
    enviarEmail() {
      let _vm = this;
      this.$store
        .dispatch("auth/sendEmail")
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Email enviado. Revisa tu correo"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el perfil: " + e
          });
        });
    },
    comprobarPedido() {
      this.$store.dispatch("pedido/comprobarPedido");
    },
    ...mapActions({}),
    comenzar() {
      let vue = this;
      //vue.$store.dispatch('pedido/resetPedido');
      this.$store.dispatch("pedido/removePedidoPendiente").then(function() {
        vue.$store.dispatch("pedido/resetPedido");
        vue.$router.push({
          path: "/pedir"
        });
      });
    },
    continuar() {
      this.$store.dispatch("pedido/navegarPagePedido");
      this.$store.commit("pedido/resetContinuePedido");
    },
    orientationEvent: function() {
      let _vue = this;

      window.addEventListener("orientationchange", function() {
        _vue.$store.commit(
          "app/setWindowOrientation",
          screen.orientation.angle
        );

        this.isTablet();
        this.isMobile();
      });
    },
    isTablet: function() {
      let _vue = this;
      let orientation =
        screen.orientation != undefined ? screen.orientation.type : "";

      let limits = orientation.includes("landscape")
        ? _vue.$vuetify.breakpoint.xs ||
          _vue.$vuetify.breakpoint.sm ||
          _vue.$vuetify.breakpoint.md
        : _vue.$vuetify.breakpoint.sm || _vue.$vuetify.breakpoint.xs;

      _vue.$store.commit("app/setIsTablet", limits);
    },
    isMobile: function() {
      let _vue = this;
      let orientation =
        screen.orientation != undefined ? screen.orientation.type : "";

      let limits = orientation.includes("landscape")
        ? _vue.$vuetify.breakpoint.xs || _vue.$vuetify.breakpoint.sm
        : _vue.$vuetify.breakpoint.xs;

      _vue.$store.commit("app/setIsMobile", limits);
    },
    setSafari: function() {
      let _vue = this;
      this.isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
    },
    mostrarMenu: function() {
      return !window.location.href.includes("/finalizar");
    }
  },
  beforeMount() {},
  mounted() {
    //crear menús
    const menuChildren = this.$router.options.routes[0].children;

    menuChildren.forEach(route => {
      let added = false;
      if (route.meta && route.meta.tucuenta) {
        this.tuCuenta.push({
          name: route.name,
          path: route.path
        });
        added = true;
      }

      if (route.meta && route.meta.superior) {
        if (route.meta.onlyAnonimous) {
          this.items.push({
            name: route.name,
            path: route.path
          });
          added = true;
        }
        if (route.meta.logged) {
          this.itemsLogueado.push({
            name: route.name,
            path: route.path
          });
          added = true;
        }
        if (!added) {
          this.itemsLogueado.push({
            name: route.name,
            path: route.path
          });
          this.items.push({
            name: route.name,
            path: route.path
          });
        }
      }
    });

    this.setSafari();
    this.orientationEvent();
    this.isTablet();
    this.isMobile();
  }
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}
</style>
<style>
.textTNone {
  text-transform: inherit !important;
}
</style>
<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}
</style>
